<template>
    <v-container
            fluid
            style="min-height: 0;"
    >
        <div v-if="intents.length === 0" class="text-xs-center pt-2 pb-2 grey--text text--darken-1">No results</div>

        <template v-else>
            <v-layout row>
                <v-flex xs12>
                    <v-card>
                        <v-list two-line>
                            <v-list-group v-for="(item, index) in intents"
                                          :key="item.Code"
                            >
                                <v-list-tile
                                    avatar
                                    ripple
                                    slot="item"
                                    @click=""
                                >
                                    <v-list-tile-content>
                                        <!--<v-list-tile-sub-title>{{ item.Code }}</v-list-tile-sub-title>-->
                                        <v-list-tile-title class="bold">{{ item.ShortDescription }}</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ item.Scopes }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-icon>keyboard_arrow_down</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile
                                    :key="item.Description"
                                    @click="details(item, index)"
                                >
                                    <v-list-tile-content>
                                        <v-list-tile-title class="grey--text text--darken-4">{{ item.Description }}</v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-list-tile-action-text>
                                            <a
                                                class="nostyle"
                                                target="_blank"
                                                :href="itemUrl(item)"
                                            >
                                                {{ item.Code }}
                                            </a>
                                        </v-list-tile-action-text>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list-group>
                        </v-list>
                    </v-card>
                </v-flex>
            </v-layout>
        </template>

        <v-btn
                absolute
                dark
                fab
                bottom
                right
                primary
                @click="add()"
        >
            <v-icon>add</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'Intents',
        data() {
            return {
                title: 'Intents',
            };
        },
        computed: {
            ...mapState('intents', {
                intents: state => state.allIntents,
            }),
        },
        methods: {
            itemUrl(item) {
                const issuer = item.Issuer;
                const intent = item.Code;
                return `https://me.nowyu.com/requests/${issuer}/${intent}?autologin=true`;
            },
            add() {
                this.$router.push({ path: '/intents/new' });
            },
            details(item) {
                this.$router.push({ path: `/intents/${item.Issuer}/${item.Code}` });
            },
        },
        created() {
            this.$store.commit('nav/BREADCRUMBS', [
                { id: 'intents', text: 'Intents', to: '/intents' },
            ]);

            this.$store.dispatch('intents/LIST_ALL');
        },
    };
</script>

<style scoped lang="stylus">
    .list--group
        .list__tile
            padding-left 32px

    a.nostyle:link
        text-decoration inherit
        color inherit
        cursor auto

    a.nostyle:visited
        text-decoration inherit
        color inherit
        cursor auto

    a[target="_blank"]:after
        font-family FontAwesome
        content ' \f08e'

</style>



// WEBPACK FOOTER //
// Intents.vue?92ac5164